module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer",
    class: _vm.answerTheme
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.answerTitle))]), (_vm.answerWords) ? _c('div', {
    staticClass: "words"
  }, [_vm._v(" " + _vm._s(_vm.answerWords))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    staticClass: "textarea",
    domProps: {
      "value": _vm.answerText
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:answerText', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped generate_audio_control"
  }, [_c('button', {
    staticClass: "button add_parameter",
    on: {
      "click": function($event) {
        return _vm.addParameter()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')) + " "), _c('span', [_vm._v("{}")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary generate_button",
    on: {
      "click": function($event) {
        return _vm.genAudio()
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.onLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.generateAudio')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary speaker"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.answerSpeaker
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:answerSpeaker', $event.target.value)
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                        " + _vm._s(speaker.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.answerEmotion
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:answerEmotion', $event.target.value)
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                        " + _vm._s(emotion.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "speed"
  }, [_c('slider', {
    attrs: {
      "size": "small",
      "value": parseFloat(_vm.answerSpeed),
      "min": 0.5,
      "step": 0.1,
      "max": 2
    },
    on: {
      "change": function($event) {
        return _vm.$emit('update:answerSpeed', $event)
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.speed')) + ": " + _vm._s(_vm.answerSpeed) + "\n                  ")], 1)]), _vm._v(" "), (_vm.answerAudio && Array.isArray(_vm.answerAudio)) ? _c('div', {
    staticClass: "audio_list"
  }, _vm._l((_vm.answerAudio), function(audio) {
    return _c('div', {
      staticClass: "audio",
      class: audio.type
    }, [(audio.type === 'url' && audio.url) ? _c('audio', {
      ref: 'onPlayer',
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": audio.url
      }
    }), _vm._v("\n                      " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (audio.type === 'url' && audio.url) ? _c('audio-player', {
      attrs: {
        "file": audio.url,
        "onLoad": _vm.onLoadAudio
      }
    }) : _vm._e(), _vm._v(" "), (audio.type === 'url' && audio.url) ? _c('div', {
      staticClass: "deleteAudio",
      attrs: {
        "title": "Удалить аудио"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAudio(audio)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-backspace fa-3x"
    })]) : _vm._e()], 1)
  }), 0) : (_vm.answerAudio && typeof _vm.answerAudio === 'string' || _vm.answerAudio instanceof String) ? _c('div', {
    staticClass: "audio_single"
  }, [_c('audio', {
    ref: 'onPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.answerAudio
    }
  }), _vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n                  ")]), _vm._v(" "), _c('audio-player', {
    attrs: {
      "file": _vm.answerAudio,
      "onLoad": _vm.onLoadAudio
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0cd678"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/Answer.vue
// module id = 398
// module chunks = 42